// set up for elastic searcher
// Use these as base, then add path decoration on consolidation
const professionFilters = [{
  name: 'freelance',
  key: 'profession-freelance',
  values: [{
    name: 'freelance',
    include: false,
    key: 'profession-freelance',
    value: false
  }]
}, {
  name: 'companyDepartmentID',
  key: 'profession-company-department-id',
  values: [{
    name: 'companyDepartmentID',
    include: false,
    key: 'profession-company-department-id',
    value: ''
  }]
}, {
  name: 'companyTypeID',
  key: 'profession-company-type-id',
  values: [{
    name: 'companyTypeID',
    include: false,
    key: 'profession-company-type-id',
    value: ''
  }]
}, {
  name: 'id',
  key: 'profession-id',
  values: [{
    name: 'id',
    include: false,
    key: 'profession-id',
    value: ''
  }]
}, {
  name: 'name.raw',
  key: 'profession-name-raw',
  values: [{
    name: 'name.raw',
    include: false,
    key: 'profession-name-raw',
    value: ''
  }]
}];

const companyAutofields = [{
  name: 'autoName',
  include: true,
  weight: 1,
  key: 'company-auto-name',
  text: 'Name',
  idField: 'id'
}];

const pcRelationshipAutoFields = [{
  name: 'name',
  include: true,
  weight: 1,
  key: 'pcr-auto-name',
  text: 'Name',
  idField: 'id'
}];

const fpRelationshipAutoFields = [{
  name: 'name',
  include: true,
  weight: 1,
  key: 'fpr-auto-name',
  text: 'Name',
  idField: 'id'
}];

const professionAutofields = [{
  name: 'name',
  include: true,
  weight: 1,
  key: 'profession-auto-name',
  text: 'Name',
  idField: 'id',
  filters: professionFilters
}];

const departmentAutofields = [{
  name: 'companyDepartmentName',
  include: true,
  weight: 1,
  key: 'department-auto-name',
  text: 'Department name',
  idField: 'companyDepartmentID',
  filters: professionFilters
}];

const companyTypeAutofields = [{
  name: 'companyTypeName',
  include: true,
  weight: 1,
  key: 'company-type-auto-name',
  text: 'Company type name',
  idField: 'companyTypeID',
  filters: professionFilters
}];

const filmFields = [{
  name: "filmName",
  include: true,
  weight: 1,
  key: 'film-name',
  text: 'Name',
  idField: 'id'
}, {
  name: "synopsis",
  include: true,
  weight: 1,
  key: 'film-synopsis',
  text: 'Synopsis',
  idField: 'id'
}, {
  name: "headline",
  include: true,
  weight: 1,
  key: 'film-headline',
  text: 'Headline',
  idField: 'id'
}, {
  name: "internationalHeadline",
  include: true,
  weight: 1,
  key: 'film-international-headline',
  text: 'International headline',
  idField: 'id'
}, {
  name: "transcript",
  include: false,
  weight: 1,
  key: 'film-transcript',
  text: 'Manual transcript',
  idField: 'id'
}];

const objectTrackingFields = [{
  name: 'ObjectTrackings.trackings.members.entityID',
  include: true,
  weight: 1,
  key: 'film-ot',
  text: 'Object tracking',
  idField: 'entityID',
  term: true
}];

const labelFields = [{
  name: "ViLabels.description",
  include: true,
  weight: 1,
  key: 'film-vilabels',
  text: 'AI labels',
  idField: 'id',
  filters: [{
    name: 'ViLabels.confidence',
    key: 'vilabels-confidence',
    values: [{
      include: true,
      key: 'confidence',
      range: {
        // gets added at query construction
        "gte": null
      }
    }]
  }, {
    name: "ViLabels.type",
    key: 'film-vilabels-type',
    values: [{
      include: false,
      key: "segment-label"
    }, {
      include: true,
      key: "shot-label"
    }, {
      include: true,
      key: "logo"
    }, {
      include: true,
      key: "transcript"
    }, {
      include: true,
      key: "text"
    }, {
      // added oct 2024 - celebrity labels can be searched on in the same way as shot labels
      include: true,
      key: "celebrity"
    }]
  }]
}];

const csPersonFields = [{
  name: "searchName",
  include: true,
  weight: 1,
  key: 'person-name',
  text: 'Name',
  idField: 'id'
}, {
  name: "id",
  include: true,
  weight: 2,
  key: 'person-id',
  text: 'Person id',
  idField: 'id'
}];

const contactFields = [{
  name: "Contacts.phone",
  include: true,
  weight: 0.5,
  key: 'contact-phone',
  text: 'Phone',
  idField: 'personID'
}, {
  name: "Contacts.mobile",
  include: true,
  weight: 1,
  key: 'contact-mobile',
  text: 'Mobile',
  idField: 'personID'
}, {
  name: "Contacts.email",
  include: true,
  weight: 1,
  key: 'contact-email',
  text: 'Email',
  idField: 'personID'
}];

const professionFields = [{
  name: "Profession.ProfessionLocalized.name",
  include: true,
  weight: 0.5,
  key: 'profession-name',
  text: 'Profession name',
  idField: 'personID'
}];

const personFields = [{
  name: "searchName",
  include: true,
  weight: 1,
  key: 'person-name',
  text: 'Name',
  idField: 'id'
}, {
  name: "biography",
  include: true,
  weight: 1,
  key: 'person-biography',
  text: 'Biography',
  idField: 'id'
}, {
  name: "interests",
  include: true,
  weight: 1,
  key: 'person-interests',
  text: 'Interests',
  idField: 'id'
}, {
  name: "aspiringTo",
  include: true,
  weight: 1,
  key: 'person-aspiring-to',
  text: 'Aspiring to',
  idField: 'id'
}, {
  name: "philosophy",
  include: true,
  weight: 1,
  key: 'person-philosophy',
  text: 'Philosophy',
  idField: 'id'
}, {
  name: "id",
  include: true,
  weight: 2,
  key: 'person-id',
  text: 'Person id',
  idField: 'id'
}];

const brandFields = [{
  name: "name",
  include: true,
  weight: 1,
  key: 'brand-name',
  text: 'Name',
  idField: 'id'
}, {
  name: "BrandToSlogans.slogan",
  include: true,
  weight: 1,
  key: 'brand-slogan',
  text: 'Slogan',
  idField: 'id'
}];

const productFields = [{
  name: "name",
  include: true,
  weight: 1,
  key: 'product-name',
  text: 'Name',
  idField: 'id'
}, {
  name: "ProductToSlogans.slogan",
  include: true,
  weight: 1,
  key: 'product-slogan',
  text: 'Slogan',
  idField: 'id'
}];

const awardFields = [{
  name: "combinedName",
  include: true,
  weight: 1,
  key: 'award-name',
  text: 'Name',
  idField: 'topLevelAwardID'
}, {
  name: "prizeYear",
  include: true,
  weight: 1,
  key: 'award-year',
  text: 'Year',
  idField: 'topLevelAwardID'
}, {
  name: "prizeName",
  include: true,
  weight: 1,
  key: 'award-prize-name',
  text: 'Prize name',
  idField: 'topLevelAwardID'
}, {
  name: "festivalName",
  include: true,
  weight: 1,
  key: 'award-festival-name',
  text: 'Festival name',
  idField: 'topLevelAwardID'
}];


const companyFields = [{
  name: "name",
  include: true,
  weight: 1,
  key: 'company-name',
  text: 'Name',
  idField: "id"
}, {
  name: "CompanyNames.abbreviatedName",
  include: true,
  weight: 1,
  key: 'company-abbreviated-name',
  text: 'Short name',
  idField: "id"
}, {
  name: "CompanyNames.localName",
  include: true,
  weight: 1,
  key: 'company-local-name',
  text: 'Local name',
  idField: 'id'
}, {
  name: "CompanyNames.localAbbreviatedName",
  include: true,
  weight: 1,
  key: 'company-local-abbreviated-name',
  text: 'Local short name',
  idField: 'id'
}, {
  name: "details",
  include: true,
  weight: 1,
  key: 'company-details',
  text: 'Details',
  idField: 'id'
}, {
  name: "experience",
  include: true,
  weight: 1,
  key: 'company-experience',
  text: 'Company experience',
  idField: 'id'
}, {
  name: "missionStatement",
  include: true,
  weight: 1,
  key: 'company-mission-statement',
  text: 'Mission statement',
  idField: 'id'
}];

const cspCompanyFields = [{
  name: "Profession.ProfessionLocalized.name",
  include: true,
  weight: 1,
  key: 'company-profession-name',
  text: 'Profession name',
  idField: 'personID'
}, {
  name: "Company.name",
  include: true,
  weight: 0.5,
  key: 'company-name',
  text: 'Name',
  idField: "companyID"
}, {
  name: "Company.CompanyNames.abbreviatedName",
  include: true,
  weight: 0.2,
  key: 'company-abbreviated-name',
  text: 'Short name',
  idField: "companyID"
}, {
  name: "Company.CompanyNames.localName",
  include: true,
  weight: 0.3,
  key: 'company-local-name',
  text: 'Local name',
  idField: 'companyID'
}, {
  name: "Company.CompanyNames.localAbbreviatedName",
  include: true,
  weight: 0.1,
  key: 'company-local-abbreviated-name',
  text: 'Local short name',
  idField: 'companyID'
}];

// most of these can be constructed by tweaking the already defined fields above
// no point repeating these over and over
const pluckLabels = {
  pluckLabelType: (source) => Object.prototype.hasOwnProperty.call(source, 'type') ? source.type : null,
  pluckId: (source) => source.filmID,
  pluckConfidence: (source) => Object.prototype.hasOwnProperty.call(source, 'confidence') ? source.confidence : null
};

const pluckOt = {
  //pluckId: (source) => source.filmID,
  pluckConfidence: (source) => Object.prototype.hasOwnProperty.call(source, 'confidence') ? source.confidence : null,
  pluckStartTime: (source) => Object.prototype.hasOwnProperty.call(source, 'startTime') ? source.startTime : null,
  pluckEndTime: (source) => Object.prototype.hasOwnProperty.call(source, 'endTime') ? source.endTime : null,
  pluckLabelType: () => 'object-label'
};
// use this to patch the fields
const patchFields = ({
  fields,
  keyPrefix,
  namePrefix,
  excludeList,
  weightMultiplier,
  agg
}) => fields.map(f => ({
  ...f,
  include: (!excludeList || excludeList.indexOf(f.key) === -1) ? f.include : false,
  key: keyPrefix + f.key,
  name: namePrefix + f.name,
  weight: (weightMultiplier || 1) * f.weight,
  agg,
  filters: f.filters ? f.filters.map(g => ({
    ...g,
    name: namePrefix + g.name,
    key: keyPrefix + g.key
  })) : null
}));

const searchFieldLists = {
  film: [{
    nested: false,
    fields: filmFields,
    type: 'film',
    text: 'Film',
    idField: 'id',
    nameField: 'filmName',
    nestPath: ''
  }, {
    nested: true,
    fields: labelFields,
    type: 'film',
    text: 'Film',
    idField: 'id',
    nameField: 'filmName',
    nestPath: 'ViLabels',
    ...pluckLabels
  }, {
    nested: true,
    fields: patchFields({
      fields: personFields,
      keyPrefix: 'film-',
      namePrefix: 'FilmToPeople.Person.'
    }),
    pluckId: (source) => source.personID,
    type: 'person',
    text: 'Person',
    idField: 'id',
    nameField: 'searchName',
    nestPath: 'FilmToPeople'
  }, {
    nested: true,
    fields: patchFields({
      fields: brandFields,
      keyPrefix: 'film-',
      namePrefix: 'FilmToBrands.Brand.'
    }),
    type: 'brand',
    text: 'Brand',
    idField: 'id',
    nameField: 'name',
    pluckId: (source) => source.brandID,
    nestPath: 'FilmToBrands'
  }, {
    nested: true,
    fields: patchFields({
      fields: productFields,
      keyPrefix: 'film-',
      namePrefix: 'FilmToProducts.Product.'
    }),
    type: 'product',
    text: 'Product',
    idField: 'id',
    nameField: 'name',
    nestPath: 'FilmToProducts',
    pluckId: (source) => source.productID
  }, {
    nested: true,
    fields: patchFields({
      fields: companyFields,
      keyPrefix: 'film-',
      namePrefix: 'FilmToCompanies.Company.'
    }),
    type: 'company',
    text: 'Company',
    idField: 'id',
    nameField: 'name',
    nestPath: 'FilmToCompanies',
    pluckId: (source) => source.companyID,
  }, {
    nested: true,
    fields: patchFields({
      fields: awardFields,
      keyPrefix: 'film-',
      namePrefix: 'FilmToAwards.'
    }),
    type: 'award',
    text: 'Award',
    idField: 'Award.id',
    nameField: 'Award.AwardLocalized.name',
    nestPath: 'FilmToAwards',
  }],
  ot: [{
    nested: true,
    fields: objectTrackingFields,
    type: 'film',
    text: 'Object tracking',
    idField: 'id',
    nameField: 'filmName',
    nestPath: 'ObjectTrackings.trackings.members',
    ...pluckOt
  }],
  profession: [{
    nested: false,
    fields: patchFields({
      fields: professionAutofields,
      keyPrefix: 'profession-',
      namePrefix: '',
      agg: true
    }),
    type: 'profession',
    text: 'Profession',
    idField: 'id',
    nameField: 'name',
    nestPath: '',
    weightMultiplier: 1,
    includeSource: false
  }, {
    nested: false,
    fields: patchFields({
      fields: companyTypeAutofields,
      keyPrefix: 'profession-',
      namePrefix: '',
      agg: true
    }),
    type: 'companytype',
    text: 'Company type',
    idField: 'companyTypeID',
    nameField: 'companyTypeName',
    nestPath: '',
    weightMultiplier: 1,
    includeSource: false
  }, {
    nested: false,
    fields: patchFields({
      fields: departmentAutofields,
      keyPrefix: 'profession-',
      namePrefix: '',
      // this needs a raw field in the mappings to work
      agg: true
    }),
    type: 'department',
    text: 'Company department',
    idField: 'companyDepartmentID',
    nameField: 'companyDepartmentName',
    nestPath: '',
    weightMultiplier: 1,
    // if the source is ever needed this will send over a stringified one
    includeSource: false,

  }],
  companyauto: [{
    nested: false,
    fields: patchFields({
      fields: companyAutofields,
      keyPrefix: 'company-',
      namePrefix: '',
      agg: true
    }),
    type: 'company',
    text: 'Company',
    idField: 'id',
    nameField: 'autoName',
    nestPath: '',
    weightMultiplier: 1,
    includeSource: false
  }],
  pcrelationship: [{
    nested: false,
    fields: patchFields({
      fields: pcRelationshipAutoFields,
      keyPrefix: 'pcr-',
      namePrefix: '',
      agg: true
    }),
    type: 'pcrelationship',
    text: 'Person to company relationship',
    idField: 'id',
    nameField: 'name',
    nestPath: '',
    weightMultiplier: 1,
    includeSource: false
  }],
  fprelationship: [{
    nested: false,
    fields: patchFields({
      fields: fpRelationshipAutoFields,
      keyPrefix: 'fpr-',
      namePrefix: '',
      agg: true
    }),
    type: 'fprelationship',
    text: 'Film to person relationship',
    idField: 'id',
    nameField: 'name',
    nestPath: '',
    weightMultiplier: 1,
    includeSource: false
  }],
  department: [{
    nested: false,
    fields: patchFields({
      fields: departmentAutofields,
      keyPrefix: 'department-',
      namePrefix: ''
    }),
    type: 'department',
    text: 'Company department',
    idField: 'companyDepartmentID',
    nameField: 'companyDepartmentName',
    nestPath: '',
    weightMultiplier: 1,
    // if the source is ever needed this will send over a stringified one
    includeSource: false
  }],
  companytype: [{
    nested: false,
    fields: patchFields({
      fields: companyTypeAutofields,
      keyPrefix: 'company-type-',
      namePrefix: ''
    }),
    type: 'companytype',
    text: 'Company type',
    idField: 'companyTypeID',
    nameField: 'companyTypeName',
    nestPath: '',
    weightMultiplier: 1,
    includeSource: false
  }],
  csperson: [{
    nested: false,
    fields: patchFields({
      fields: csPersonFields,
      keyPrefix: 'csperson-',
      namePrefix: ''
    }),
    type: 'person',
    text: 'Person',
    idField: 'id',
    nameField: 'searchName',
    nestPath: '',
    weightMultiplier: 2,
  },
  {
    nested: true,
    fields: patchFields({
      fields: contactFields,
      keyPrefix: 'csperson-',
      namePrefix: ''
    }),
    type: 'person',
    text: 'Person',
    idField: 'personID',
    nameField: 'contactDetails',
    nestPath: 'Contacts'
  }, {
    nested: true,
    fields: patchFields({
      fields: professionFields,
      keyPrefix: 'csperson-film-',
      namePrefix: 'PersonToFilms.'
    }),
    pluckId: (source) => source.personID,
    type: 'person',
    text: 'Person',
    idField: 'personID',
    nameField: 'personID',
    nestPath: 'PersonToFilms',
    weightMultiplier: 0.5,
  }, {
    nested: true,
    fields: patchFields({
      fields: cspCompanyFields,
      keyPrefix: 'csperson-',
      namePrefix: 'PersonToCompanies.'
    }),
    type: 'company',
    text: 'Company',
    idField: 'companyID',
    nameField: 'companyID',
    nestPath: 'PersonToCompanies',
    weightMultiplier: 0.2,
  }
  ],
  person: [{
    nested: false,
    fields: patchFields({
      fields: personFields,
      keyPrefix: 'person-',
      namePrefix: ''
    }),
    type: 'person',
    text: 'Person',
    idField: 'id',
    nameField: 'searchName',
    nestPath: ''
  }, {
    nested: true,
    fields: patchFields({
      fields: filmFields,
      keyPrefix: 'person-',
      namePrefix: 'PersonToFilms.Film.'
    }),
    pluckId: (source) => source.filmID,
    type: 'film',
    text: 'Film',
    idField: 'id',
    nameField: 'filmName',
    nestPath: 'PersonToFilms'
  }, {
    nested: true,
    fields: patchFields({
      fields: companyFields,
      keyPrefix: 'person-',
      namePrefix: 'PersonToCompanies.Company.',
      excludeList: ['company-details', 'company-mission-statement', 'company-experience']
    }),
    pluckId: (source) => source.companyID,
    type: 'company',
    text: 'Company',
    idField: 'id',
    nameField: 'name',
    nestPath: 'PersonToCompanies'
  }, {
    nested: true,
    fields: patchFields({
      fields: awardFields,
      keyPrefix: 'person-',
      namePrefix: 'PersonToAwards.'
    }),
    type: 'award',
    text: 'Award',
    idField: 'Award.id',
    nameField: 'Award.AwardLocalized.name',
    nestPath: 'PersonToAwards',
  }],
  company: [{
    nested: false,
    fields: patchFields({
      fields: companyFields,
      keyPrefix: 'company-',
      namePrefix: ''
    }),
    type: 'company',
    text: 'Company',
    idField: 'id',
    nameField: 'name',
    nestPath: ''
  }, {
    nested: true,
    fields: patchFields({
      fields: filmFields,
      keyPrefix: 'company-',
      namePrefix: 'CompanyToFilms.Film.'
    }),
    type: 'film',
    text: 'Film',
    idField: 'id',
    nameField: 'filmName',
    nestPath: 'CompanyToFilms',
    pluckId: (source) => source.filmID
  }, {
    nested: true,
    fields: patchFields({
      fields: labelFields,
      keyPrefix: 'company-',
      namePrefix: 'CompanyToFilms.Film.'
    }),
    type: 'film',
    text: 'Film',
    idField: 'filmID',
    nameField: 'filmName',
    nestPath: 'CompanyToFilms.Film.ViLabels',
    ...pluckLabels
  }, {
    nested: true,
    fields: patchFields({
      fields: brandFields,
      keyPrefix: 'company-',
      namePrefix: 'CompanyToBrands.Brand.'
    }),
    type: 'brand',
    text: 'Brand',
    idField: 'id',
    nameField: 'name',
    nestPath: 'CompanyToBrands',
    pluckId: (source) => source.brandID
  }, {
    nested: true,
    fields: patchFields({
      fields: productFields,
      keyPrefix: 'company-',
      namePrefix: 'CompanyToProducts.Product.'
    }),
    type: 'product',
    text: 'Product',
    idField: 'id',
    nameField: 'name',
    nestPath: 'CompanyToProducts',
    pluckId: (source) => source.productID
  }, {
    nested: true,
    fields: patchFields({
      fields: personFields,
      keyPrefix: 'company-',
      namePrefix: 'CompanyToPeople.Person.'
    }),
    type: 'person',
    text: 'Person',
    idField: 'id',
    nameField: 'searchName',
    nestPath: 'CompanyToPeople',
    pluckId: (source) => source.personID
  }],
  award: [],
  brand: [{
    nested: false,
    fields: patchFields({
      fields: brandFields,
      keyPrefix: 'brand-',
      namePrefix: ''
    }),
    type: 'brand',
    text: 'Brand',
    idField: 'id',
    nameField: 'name',
    nestPath: ''
  }, {
    nested: true,
    fields: patchFields({
      fields: filmFields,
      keyPrefix: 'brand-',
      namePrefix: 'BrandToFilms.Film.'
    }),
    type: 'film',
    text: 'Film',
    idField: 'id',
    nameField: 'filmName',
    nestPath: 'BrandToFilms',
    pluckId: (source) => source.filmID
  }, {
    nested: true,
    fields: patchFields({
      fields: labelFields,
      keyPrefix: 'brand-',
      namePrefix: 'BrandToFilms.Film.'
    }),
    type: 'film',
    text: 'Film',
    idField: 'filmID',
    nameField: 'filmName',
    nestPath: 'BrandToFilms.Film.ViLabels',
    ...pluckLabels
  }, {
    nested: true,
    fields: patchFields({
      fields: companyFields,
      keyPrefix: 'brand-',
      namePrefix: 'BrandToCompanies.Company.',
      excludeList: ['company-details', 'company-mission-statement', 'company-experience']
    }),
    type: 'company',
    text: 'Company',
    idField: 'id',
    nameField: 'name',
    nestPath: 'BrandToCompanies',
    pluckId: (source) => source.companyID
  }, {
    nested: true,
    fields: patchFields({
      fields: productFields,
      keyPrefix: 'brand-',
      namePrefix: 'BrandToProducts.Product.'
    }),
    type: 'brand',
    text: 'Brand',
    idField: 'id',
    nameField: 'name',
    nestPath: 'BrandToProducts',
    pluckId: (source) => source.productID
  }],
  product: [{
    nested: false,
    fields: patchFields({
      fields: productFields,
      keyPrefix: 'product-',
      namePrefix: ''
    }),
    type: 'product',
    text: 'Product',
    idField: 'id',
    nameField: 'name',
    nestPath: ''
  }, {
    nested: true,
    fields: patchFields({
      fields: filmFields,
      keyPrefix: 'product-',
      namePrefix: 'ProductToFilms.Film.'
    }),
    type: 'film',
    text: 'Film',
    idField: 'id',
    nameField: 'filmName',
    nestPath: 'ProductToFilms',
    pluckId: (source) => source.filmID
  }, {
    nested: true,
    fields: patchFields({
      fields: labelFields,
      keyPrefix: 'product-',
      namePrefix: 'ProductToFilms.Film.'
    }),
    type: 'film',
    text: 'Film',
    idField: 'filmID',
    nameField: 'filmName',
    nestPath: 'ProductToFilms.Film.ViLabels',
    ...pluckLabels
  }, {
    nested: true,
    fields: patchFields({
      fields: companyFields,
      keyPrefix: 'product-',
      namePrefix: 'ProductToCompanies.Company.',
      excludeList: ['company-details', 'company-mission-statement', 'company-experience']
    }),
    type: 'company',
    text: 'Company',
    idField: 'id',
    nameField: 'name',
    nestPath: 'ProductToCompanies',
    pluckId: (source) => source.companyID
  }, {
    nested: true,
    fields: patchFields({
      fields: brandFields,
      keyPrefix: 'product-',
      namePrefix: 'ProductToBrands.Brand.'
    }),
    type: 'brand',
    text: 'Brand',
    idField: 'id',
    nameField: 'name',
    nestPath: 'ProductToBrands',
    pluckId: (source) => source.brandID
  }]
};

// this combines all the possible fields and indexes them by key
const getTypeDefinition = ({
  type
}) => {
  const searchFieldList = searchFieldLists[type];
  if (!searchFieldList) {
    throw new Error(`${type} missing from searchfieldlists`);
  }
  // flatten all the fields to make them easier to deal with
  const allFields = searchFieldList.reduce((p, c) => {
    c.fields.forEach(f => {
      if (p[f.key]) throw new Error(`duplicate.key ${f.key} in field list`);
      p[f.key] = {
        ...f,
        nested: c.nested,
        nestPath: c.nestPath,
        type: c.type,
        pluckId: c.pluckId,
        pluckConfidence: c.pluckConfidence,
        pluckLabelType: c.pluckLabelType,
        pluckStartTime: c.pluckStartTime,
        pluckEndTime: c.pluckEndTime
      };
    });
    return p;
  }, {});

  // make default includes list
  const defaultIncludes = Object.keys(allFields)
    .filter(f => allFields[f].include)
    .map(f => {
      const ob = allFields[f];
      const dob = {
        key: ob.key,
        weight: ob.weight
      };
      // for now filters are not supported in the client
      // TODO will add later if necessary
      // the elastic search supports them, but unlikely to be necessary for now
      // so not creating them will simply mean elastic uses the defaults
      return dob;
    });

  return {
    searchFieldList,
    allFields,
    defaultIncludes
  };
};

// these are the matchreason fields required
const reasonIdFields = {
  person: 'personID',
  film: 'filmID',
  brand: 'brandID',
  product: 'productID',
  company: 'companyID',
  award: 'awardID',
  profession: 'professionID',
  companytype: 'companyTypeID',
  department: 'companyDepartmentID'
};

const reasonFields = Object.keys(reasonIdFields).map(k => reasonIdFields[k]);

const reasonNulls = reasonFields.reduce((p, c) => {
  p[c] = null;
  return p;
}, {});

// when a mutation happens, this is used to discover everything that needs 
// re-indexing in elastic
const gidField = 'id';
const reindexMap = {
  brand: [{
    type: 'brand',
    idField: 'id',
    gQuery: 'riBrands',
    gPluck: 'brandID'
  }, {
    type: 'product',
    idField: 'ProductToBrands.brandID',
    gPluck: 'BrandToProducts.productID',
    path: 'ProductToBrands'
  },
  {
    type: 'company',
    idField: 'CompanyToBrands.brandID',
    gPluck: 'BrandToCompanies.companyID',
    path: 'CompanyToBrands'
  }, {
    type: 'film',
    idField: 'FilmToBrands.brandID',
    gPluck: 'BrandToFilms.filmID',
    path: 'FilmToBrands'
  }
  ],
  product: [{
    type: 'product',
    idField: 'id',
    gQuery: 'riProducts',
    gPluck: 'productID'
  }, {
    type: 'film',
    idField: 'FilmToProducts.productID',
    gPluck: 'ProductToFilms.filmID',
    path: 'FilmToProducts'
  }, {
    type: 'company',
    idField: 'CompanyToProducts.productID',
    gPluck: 'ProductToCompanies.filmID',
    path: 'CompanyToProducts'
  }, {
    type: 'brand',
    idField: 'BrandToProducts.productID',
    gPluck: 'ProductToBrands.brandID',
    path: 'BrandToProducts'
  }],
  company: [{
    type: 'company',
    idField: 'id',
    gQuery: 'riCompanies',
    gPluck: 'companyID'
  }, {
    type: 'film',
    idField: 'FilmToCompanies.companyID',
    gPluck: 'CompanyToFilms.filmID',
    path: 'FilmToCompanies'
  }, {
    type: 'product',
    idField: 'ProductToCompanies.companyID',
    gPluck: 'CompanyToProducts.productID',
    path: 'ProductToCompanies'
  }, {
    type: 'brand',
    idField: 'BrandToCompanies.companyID',
    gPluck: 'CompanyToBrands.brandID',
    path: 'BrandToCompanies'
  }, {
    type: 'person',
    idField: 'PersonToCompanies.companyID',
    gPluck: 'CompanyToPeople.personID',
    path: 'PersonToCompanies'
  }],
  person: [{
    type: 'person',
    idField: 'id',
    gQuery: 'riPeople',
    gPluck: 'personID'
  }, {
    type: 'film',
    idField: 'FilmToPeople.personID',
    gPluck: 'PersonToFilms.filmID',
    path: 'FilmToPeople'
  }, {
    type: 'company',
    idField: 'CompanyToPeople.personID',
    gPluck: 'PersonToCompanies.companyID',
    path: 'CompanyToPeople'
  }],
  film: [{
    type: 'film',
    idField: 'id',
    gQuery: 'riFilms',
    gPluck: 'filmID'
  }, {
    type: 'person',
    idField: 'PersonToFilms.filmID',
    gPluck: 'FilmToPeople.personID',
    path: 'PersonToFilms'

  }, {
    type: 'company',
    idField: 'CompanyToFilms.filmID',
    gPluck: 'FilmToCompanies.companyID',
    path: 'CompanyToFilms'

  }, {
    type: 'product',
    idField: 'ProductToFilms.filmID',
    gPluck: 'FilmToProducts.productID',
    path: 'ProductToFilms'
  }, {
    type: 'brand',
    idField: 'BrandToFilms.filmID',
    gPluck: 'FilmToBrands.brandID',
    path: 'BrandToFilms'
  }]
};
// these are all the label types that could be generated
const viLabelTypes = {
  'shot-label': {
    feature: 'all'
  },
  'object-label': {
    feature: 'all'
  },
  'frame-label': {
    feature: 'all'
  },
  'segment-label': {
    feature: 'all'
  },
  'text': {
    feature: 'all'
  },
  'logo': {
    feature: 'all'
  },
  'transcript': {
    feature: 'transcription'
  }
};
const minOTConfidence = 0.7;
const minVLConfidence = 0.5;

const indexNames = {
  searcher: 'fidsearcher',
  testSearcher: 'testfidsearcher'
};
const getIndexName = ({
  name,
  type
}) => {
  return indexNames[name] + type;
};
// itemid is a merge of the type and the id
const getItemID = ({
  fid_type,
  fid_id
}, index) => `${fid_type}-${fid_id}${typeof index === typeof undefined ? '' : ('-' + index)}`;

export  {
  getItemID,
  getIndexName,
  getTypeDefinition,
  reasonFields,
  reasonNulls,
  reasonIdFields,
  gidField,
  reindexMap,
  viLabelTypes,
  // confidences below these are not added to the elastic index
  // although they will exist in the databse
  // all will be visibile through object trackingor labels in the UI
  minOTConfidence,
  minVLConfidence
};